import React, { useState } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <nav className="px-6 py-4">
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
              <i className="ri-star-fill text-white text-xl"></i>
            </div>
            <div className="text-2xl font-bold text-black" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Ad Astra Fractional CFO
            </div>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('problems')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              The Problems We Solve
            </button>
            <button 
              onClick={() => scrollToSection('how-we-solve')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              How We Solve Problems
            </button>
            <button 
              onClick={() => scrollToSection('benefits')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Benefits
            </button>
            <button 
              onClick={() => scrollToSection('consultation')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            >
              Contact
            </button>
            <Button 
              onClick={() => scrollToSection('consultation')}
              size="sm"
            >
              Book a Call
            </Button>
          </div>
          
          <button 
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
        
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
            <div className="flex flex-col space-y-3 pt-4">
              <button 
                onClick={() => scrollToSection('problems')}
                className="text-left text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                The Problems We Solve
              </button>
              <button 
                onClick={() => scrollToSection('how-we-solve')}
                className="text-left text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                How We Solve Problems
              </button>
              <button 
                onClick={() => scrollToSection('benefits')}
                className="text-left text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                Benefits
              </button>
              <button 
                onClick={() => scrollToSection('consultation')}
                className="text-left text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                Contact
              </button>
              <Button 
                onClick={() => scrollToSection('consultation')}
                size="sm"
                className="w-fit"
              >
                Book a Call
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
